package net.sergeych.ugdx.shared.api

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import net.sergeych.kiloparsec.command
import net.sergeych.ugdx.shared.SignedInvoice

@Serializable
data class InvoicePayArgs(
    val invoiceUniqieId: String,
    val accountId: Long
)
val cmdInvoiceSubmit by command<SignedInvoice,SignedInvoice>()

@Serializable
data class InvoiceIdArgs(val uniqueId: String)

val cmdInvoiceGet by command<InvoiceIdArgs,SignedInvoice>()
val cmdInvoicePay by command<InvoicePayArgs,SignedInvoice>()
val cmdInvoiceReject by command<InvoiceIdArgs,Unit>()

@Serializable
data class InvoiceListArgs(
    val since: Instant,
    val until: Instant,
    val showNew: Boolean,
    val showPaid: Boolean,
    val showRejected: Boolean,
    val limit: Int = 50,
)

/**
 * List of invoices returned by the service in the _requested interval_ in respect with [SignedInvoice.createdAt]
 * field value.
 *
 * Important note. Service decide how many invoices to return and may override requested amount. To get all the invoices
 * in some period, check the [hasMore] value. It it is true, you should get the __oldest `SignedInvoice` from
 * the returned list__ and use its `createdAt` to get more invoices older than this once. Note that intervals
 * _must overlap_ as there could be several invoices with the same creation time, so filter the resulting list for dupes.
 *
 * We recommend using [SignedInvoice.all] that takes care of all this.
 *
 * @param since the beginning of the requested interval, inclusive
 * @param until the end of the requested interval, exclusive
 * @param signedInvoices list of invoices in the interval, could be incomplete
 * @param hasMore true if there are more invoices in the interval than were returned.
 */
@Serializable
data class InvoiceListResult(
    val since: Instant,
    val until: Instant,
    val signedInvoices: List<SignedInvoice>,
    val hasMore: Boolean
)

val cmdInvoiceList by command<InvoiceListArgs,InvoiceListResult>()
